import router from "./router";
import { useAuthStore } from '@/stores'

const featuredNavItems = [
    {
        label: "Jobs Dashboard",
        icon: "mdi-monitor-dashboard",
        onClick: () => {
            const url = new URL(process.env.VUE_APP_API_URL)
            const dashboardUrl = `${url.protocol}//${url.host}/hangfire`
            window.location.href= dashboardUrl
        }
    }
]

const configurationNavItems = [
    {
        label: "Settings",
        icon: "mdi-cogs",
        to:"/admin/tenants/1"
    },
    {
        label: "Dashboard Configs",
        icon: "mdi-view-dashboard-edit",
        to: "/admin/dashboard-configs"
    },
    {
        label: "System Settings",
        icon: "mdi-cog-outline",
        to: "/admin/system"
    }
]

export default {
    router,
    featuredNavItems,
    configurationNavItems
}
